export const SubfamilyType = Object.freeze({
    CHEMICAL_SUBFAMILY: 0,
    EQUIPMENT_SUBFAMILY: 1
});